import { makeStyles } from "@mui/styles"

const useStyles = makeStyles(() => ({
  root: {
    width: "100%",
    // height: "100vh",
    overflow: "auto",
    overflowX: "hidden",
    fontFamily: "Roboto",
    "@media all and (max-width: 900px)": {
      height: "100vh",
      marginTop: 80,
    },
  },
  boxTable: {
    width: "90%",
    marginLeft: "5%",
    background: "#f9f9f9",
    boxShadow: "0px 1px 4px rgba(36, 55, 143, 0.2)",
    borderRadius: 10,
    marginTop: "1rem",
  },
  boxtitle: {
    width: "90%",
    display: "flex",
    marginLeft: "5%",
    color: "#4B4952",
    paddingTop: "1rem",
  },
  title: {
    fontSize: "2em",
    letterSpacing: "0.04rem",
    "@media all and (max-width: 600px)": {
      fontSize: "1.5em",
    },
  },
  boxSubTitle: {
    width: "90%",
    display: "flex",
    alignItems: "center",
    color: "#4B4952",
    background: "#f9f9f9",
    boxShadow: "0px 1px 4px rgba(36, 55, 143, 0.2)",
    borderRadius: 10,
    paddingBottom: 10,
    paddingTop: 10,
    marginLeft: "5%",
    marginTop: "1rem",
    "@media all and (max-width: 600px)": {
      fontSize: "0.8em",
    },
  },
  subtitle: {
    fontSize: "1rem",
    marginLeft: 8,
    fontWeight: "bold",
    "@media all and (max-width: 600px)": {
      fontSize: "1em",
    },
  },
  boxSearchBar: {
    width: "95%",
    display: "flex",
    padding: "25px 25px",

    alignItems: "center",
  },
  containerSearchValueButton: {
    width: "100%",
    display: "flex",
    alignItems: "center",
    flexWrap: "wrap",
  },
  buttonResetFilterCUIT: {
    height: "30px",
    width: "150px",
    padding: "5px",
    margin: "5px 10px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#f2f2f2",
    cursor: "pointer",
    border: "2px solid #028B7E",
    borderRadius: "23px",
    "&:hover": {
      backgroundColor: "#fff",
      border: "3px solid #028B7E",
    },
    "@media all and (max-width: 600px)": {
      height: "28px",
      width: "110px",
    },
  },

  buttonResetFilterClientName: {
    height: "30px",
    padding: "5px 10px",
    margin: "5px 10px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#f2f2f2",
    cursor: "pointer",
    border: "2px solid #028B7E",
    borderRadius: "23px",
    "&:hover": {
      backgroundColor: "#fff",
      border: "3px solid #028B7E",
    },
  },
  closeIconButtonReset: {
    fontSize: "16px",
    color: "#028B7E",
    "@media all and (max-width: 600px)": {
      fontSize: "11px",
    },
  },
  typographyButton: {
    fontFamily: "Raleway",
    fontSize: "14px",
    letterSpacing: "0.05em",
    color: "#028B7E",
    "@media all and (max-width: 600px)": {
      fontSize: "11px",
    },
  },
}))

export default useStyles
